import { OffcanvasFormTitleProps } from "./types";
import { Offcanvas } from "react-bootstrap";

export default function Title(props: OffcanvasFormTitleProps){
    return <Offcanvas.Title {...props}/>
}